import axios from "axios";

export const api = axios.create({
  //baseURL: "http://127.0.0.1:8001/api",
  baseURL: process.env.REACT_APP_API_URL || "https://api.weddingtouch.in/api",
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;

  if (detail == null) {
    return err?.message || "Something went wrong";
  }

  if (typeof detail === "string") {
    return detail;
  }

  if (Array.isArray(detail)) {
    return detail
      .map((e) =>
        e && typeof e.msg === "string"
          ? e.msg
          : JSON.stringify(e)
      )
      .join(" ");
  }

  if (typeof detail.msg === "string") {
    return detail.msg;
  }

  return String(detail);
}
async function optimizeWebsiteImage(file) {
  // Keep admin uploads reliable on production/CDN connections: resize large camera
  // originals in the browser before sending them to the API.
  if (!file?.type?.startsWith("image/")) return file;
  const bitmap = await createImageBitmap(file);
  const maxSide = 1920;
  const scale = Math.min(1, maxSide / Math.max(bitmap.width, bitmap.height));
  const canvas = document.createElement("canvas");
  canvas.width = Math.max(1, Math.round(bitmap.width * scale));
  canvas.height = Math.max(1, Math.round(bitmap.height * scale));
  const ctx = canvas.getContext("2d", { alpha: false });
  ctx.drawImage(bitmap, 0, 0, canvas.width, canvas.height);
  bitmap.close?.();
  const blob = await new Promise((resolve) => canvas.toBlob(resolve, "image/jpeg", 0.9));
  return blob ? new File([blob], (file.name || "website-image").replace(/\.[^.]+$/, "") + ".jpg", { type: "image/jpeg" }) : file;
}

export async function uploadWebsiteImage(file, kind = "gallery") {
  const uploadFile = await optimizeWebsiteImage(file);
  const fd = new FormData();
  fd.append("file", uploadFile);
  fd.append("kind", kind);
  // Do not manually set multipart Content-Type. The browser must add its boundary;
  // manually forcing the header can surface as a production "Network Error".
  const { data } = await api.post("/media/website", fd, { timeout: 120000 });
  return data;
}
